const permissions = {
    en: {
        "perm.title": "Permissions",
        "perm.capability": "Capability",
        "perm.hint": "Admin always has full access. Toggle what each other role can do.",
        "perm.saved": "Permission updated",
        "perm.role_moderator": "Moderator",
        "perm.role_dispecher": "Dispatcher",
        "perm.role_superviser": "Supervisor",
        "perm.role_user": "Dealer",
    },
    ru: {
        "perm.title": "Права доступа",
        "perm.capability": "Право",
        "perm.hint": "Админ всегда имеет полный доступ. Настройте права остальных ролей.",
        "perm.saved": "Права обновлены",
        "perm.role_moderator": "Модератор",
        "perm.role_dispecher": "Диспетчер",
        "perm.role_superviser": "Супервайзер",
        "perm.role_user": "Дилер",
    },
    geo: {
        "perm.title": "უფლებები",
        "perm.capability": "უფლება",
        "perm.hint": "ადმინს ყოველთვის აქვს სრული წვდომა. დაარეგულირეთ დანარჩენი როლების უფლებები.",
        "perm.saved": "უფლება განახლდა",
        "perm.role_moderator": "მოდერატორი",
        "perm.role_dispecher": "დისპეტჩერი",
        "perm.role_superviser": "ზედამხედველი",
        "perm.role_user": "დილერი",
    },
};

export default permissions;
